export const getResources = () =>
    window.performance.getEntriesByType('resource');
    